import React, { useCallback, useMemo } from 'react'

import CreateTripItem from '../Create'
import SearchTourOrCruise from '../Search/SearchTourOrCruise'

import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import LineEditAltIcon from 'components/Luxkit/Icons/line/LineEditAltIcon'
import LineSearchIcon from 'components/Luxkit/Icons/line/LineSearchIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

interface Props {
  tripId: string
  defaultDate?: string
  sectionId?: string
}

function SelectTourType(props: Props) {
  const { tripId, sectionId, defaultDate } = props

  const openModal = useOpenModal()
  const { closeModal, goBack } = useModalCallbacks()

  const handleSearchTourClick = useCallback(() => {
    openModal(SearchTourOrCruise, { tripId, sectionId })
  }, [openModal, sectionId, tripId])

  const handleAddCustomTourClick = useCallback(() => {
    openModal(CreateTripItem, {
      itemType: 'TOURS' as const,
      tripId,
      defaultDate,
    })
  }, [defaultDate, openModal, tripId])

  const listItemsData = useMemo(
    () => [
      {
        startIcon: <LineSearchIcon />,
        endIcon: <LineAngleRightIcon />,
        key: 'searchTour',
        title: 'Search Luxury Escape Offers',
        subtitle: 'Find the world’s best escapes, handpicked by experts',
        onClick: handleSearchTourClick,
      },
      {
        startIcon: <LineEditAltIcon />,
        endIcon: <LineAngleRightIcon />,
        key: 'addCustomAccommodation',
        title: 'Add your own tour',
        subtitle: 'Enter details of your own booking',
        onClick: handleAddCustomTourClick,
      },
    ],
    [handleAddCustomTourClick, handleSearchTourClick],
  )

  return (
    <>
      <ModalHeader
        title="Tour"
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          {listItemsData.map((item) => (
            <ListItem
              key={item.key}
              startIcon={item.startIcon}
              endIcon={item.endIcon}
              title={item.title}
              subtitle={item.subtitle}
              onClick={item.onClick}
            />
          ))}
        </ModalContent>
      </ModalBody>
    </>
  )
}

export default SelectTourType
